<template>
  <div>
    <b-row v-for="s in propertiesFiltered">
      <b-col v-if="s.__type !== 'array'" md="9">
        {{ getPropertyDescription(s.name) }}
      </b-col>
      <b-col v-if="s.__type !== 'array'" md="3" class="text-right">
        {{ getTaxRateValue(s) }}
      </b-col>

      <b-col v-if="s.__type === 'array'" md="3" >
        {{ getPropertyDescription(s.name) }}
      </b-col>
      <b-col v-if="s.__type === 'array'" md="9">
        <MarketFee :properties="s.value" :propertyDescriptions="propertyDescriptions"/>
      </b-col>

    </b-row>
  </div>
</template>

<script>

import { MarketFee } from '../components/index'

export default {
  name: 'MarketFee',
  props: {
    properties: null,
    propertyDescriptions: null
  },
  components: {
    MarketFee
  },
  data () {
    return {
    }
  },
  methods: {
    getPropertyDescription(name) {
      const pd = this.propertyDescriptions.find(x => x.Name === name)
      if (pd) {
        return pd.Description
      } else {
        return name
      }
    },
    getTaxRateValue(marketFee) {
      if (marketFee.__type === 'boolean') {
        return 'true / false'
      }

      return this.getFormattedValue(marketFee)
    },
    getFormattedValue(marketFee) {
      let formattedValue = marketFee.value !== null ? marketFee.value.toString() : ''
      if (marketFee.__type === 'decimal') {
        const indexOfDecimal = marketFee.value.toString().indexOf('.')
        if (indexOfDecimal > 0) {
          if (formattedValue.length == indexOfDecimal + 3) {
            formattedValue = parseFloat(formattedValue).toFixed(2).toString().substring(0, indexOfDecimal + 3)
          }
          if (formattedValue.length >= indexOfDecimal + 4) {
            formattedValue = parseFloat(formattedValue).toString().substring(0, indexOfDecimal + 4)
          }
        }

        if (marketFee.name.toLowerCase().endsWith('pct')) {
          formattedValue += ' %'
        }
      }
      if (marketFee.__type.toString().indexOf('nullable') > -1) {
        if(marketFee.value !== null && marketFee.value !== undefined) {
          const indexOfDecimal = marketFee.value.toString().indexOf('.')
          if (indexOfDecimal > 0) {
            if (formattedValue.length == indexOfDecimal + 3) {
              formattedValue = parseFloat(formattedValue).toFixed(2).toString().substring(0, indexOfDecimal + 3)
            }
            if (formattedValue.length >= indexOfDecimal + 4) {
              formattedValue = parseFloat(formattedValue).toString().substring(0, indexOfDecimal + 4)
            }
          }

          if (marketFee.name.toLowerCase().endsWith('pct')) {
            formattedValue += ' %'
          }
        } else {
          formattedValue = "nullable"
        }
      }
      return formattedValue
    },
  },
  computed: {
      propertiesFiltered() {
        const properties = []
        this.properties.forEach(x => {
          if (x.name !== 'CalculateRegistrationFee' &&
            x.name !== 'RegistrationFee') {
              properties.push(x)
            }
        })

        return properties
      }
    }
  }
</script>

<style>
  .max-width {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/MarketFee.vue